import { Component, OnInit } from '@angular/core';
import {single, multi} from '../../../interfaces/data';

@Component({
  selector: 'app-advanced-pie',
  templateUrl: './advanced-pie.component.html',
  styleUrls: ['./advanced-pie.component.css']
})
export class AdvancedPieComponent implements OnInit {
  single: any[];
  multi: any[];
  
  view: any[] = [700, 300];

  colorScheme = {
    domain: ['#00B2FF', '#FF2906', '#0B18F5', '#C2B36C']
  };
  constructor() { 
    Object.assign(this, {single, multi})   

  }

  ngOnInit() {
  }

  onSelect(event) {
    console.log(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/graficos/advanced-pie/advanced-pie.component.ts